// src/components/Footer.jsx

export default function Footer() {
  const scrollToSection = (id) => {
    if (typeof window === "undefined") return;
    const el = document.getElementById(id);
    if (!el) return;

    const navOffset = 80;
    const y = el.getBoundingClientRect().top + window.scrollY - navOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const scrollToTop = () => {
    if (typeof window === "undefined") return;
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative overflow-hidden bg-[#0f172a] text-white">
      {/* Fondo con colores Zentra */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_10%,rgba(93,131,243,0.28),transparent_32%),linear-gradient(135deg,#0f172a_0%,#204b97_58%,#5d83f3_100%)]" />
      <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
      <div className="absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-[#5d83f3]/30 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-2xl backdrop-blur-md md:p-8">
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-[1.35fr_0.75fr_0.75fr_1fr]">
            {/* Columna: Marca */}
            <div>
              <button
                type="button"
                onClick={scrollToTop}
                className="inline-flex items-center"
                aria-label="Ir al inicio"
              >
                <img
                  src="/img/logotipo-largo-blanco.svg"
                  alt="Zentra Group"
                  className="h-12 w-auto"
                />
              </button>

              <p className="mt-5 max-w-sm text-sm leading-6 text-white/80">
                Desarrollo de software, páginas web, sistemas personalizados,
                GPS y soluciones POS para negocios que quieren ordenar,
                automatizar y crecer.
              </p>

              <div className="mt-6 inline-flex rounded-full border border-white/15 bg-white/10 px-4 py-2 text-xs font-semibold uppercase tracking-[0.22em] text-white/85">
                Software a medida
              </div>
            </div>

            {/* Columna: Navegación */}
            <div>
              <h5 className="text-lg font-semibold">Explorar</h5>

              <ul className="mt-5 space-y-3 text-sm text-white/80">
                <li>
                  <button
                    type="button"
                    onClick={scrollToTop}
                    className="text-left transition hover:translate-x-1 hover:text-white"
                  >
                    Inicio
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    onClick={() => scrollToSection("nosotros")}
                    className="text-left transition hover:translate-x-1 hover:text-white"
                  >
                    Nosotros
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    onClick={() => scrollToSection("servicios")}
                    className="text-left transition hover:translate-x-1 hover:text-white"
                  >
                    Servicios
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    onClick={() => scrollToSection("pricing")}
                    className="text-left transition hover:translate-x-1 hover:text-white"
                  >
                    GPS
                  </button>
                </li>
              </ul>
            </div>

            {/* Columna: Páginas */}
            <div>
              <h5 className="text-lg font-semibold">Legal y Accesos</h5>

              <ul className="mt-5 space-y-3 text-sm text-white/80">
                 <li>
      <a
        href="/legal"
        className="inline-block text-left transition hover:translate-x-1 hover:text-white"
      >
        Términos y Condiciones
      </a>
    </li>

                <li>
      <a
        href="/cliente"
        className="inline-block text-left transition hover:translate-x-1 hover:text-white"
      >
        Cliente
      </a>
    </li>

              </ul>
            </div>

            {/* Columna: Contacto */}
            <div className="lg:justify-self-end lg:text-right">
              <h5 className="text-lg font-semibold">Contacto</h5>

              <div className="mt-5 space-y-3 text-sm text-white/80">
                <p>
                  <span className="font-semibold text-white">Teléfono:</span>{" "}
                  <a
                    href="tel:+56968585106"
                    className="transition hover:text-white"
                  >
                    +569 68585106
                  </a>
                </p>

                <p>
                  <span className="font-semibold text-white">Correo:</span>{" "}
                  <a
                    href="mailto:soporte@zentragroup.cl"
                    className="transition hover:text-white"
                  >
                    soporte@zentragroup.cl
                  </a>
                </p>
              </div>

              <div className="mt-6 flex gap-3 lg:justify-end">
                <a
                  aria-label="Instagram"
                  href="https://www.instagram.com/zentragroupcl/"
                  target="_blank"
                  rel="noreferrer"
                  className="grid h-11 w-11 place-items-center rounded-2xl border border-white/20 bg-white/10 transition hover:-translate-y-1 hover:bg-white/20"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm10 2H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm-5 3a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 .001 6.001A3 3 0 0 0 12 9zm5.5-2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
                  </svg>
                </a>

                <a
                  aria-label="Facebook"
                  href="https://www.facebook.com/share/1Cqe4PgoRt/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noreferrer"
                  className="grid h-11 w-11 place-items-center rounded-2xl border border-white/20 bg-white/10 transition hover:-translate-y-1 hover:bg-white/20"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M22 12a10 10 0 1 0-11.6 9.9v-7h-2.2v-2.9h2.2V9.4c0-2.2 1.3-3.4 3.3-3.4.9 0 1.8.16 1.8.16v2h-1c-1 0-1.3.64-1.3 1.3v1.7h2.5l-.4 2.9h-2.1v7A10 10 0 0 0 22 12z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Barra inferior */}
          <div className="mt-10 border-t border-white/15 pt-6">
            <div className="flex flex-col items-center justify-between gap-4 text-sm text-white/70 md:flex-row">
              <p>
                © {new Date().getFullYear()} Zentra Group. Todos los derechos
                reservados.
              </p>

              <div className="rounded-full bg-white px-5 py-2 shadow-[0_12px_30px_rgba(15,23,42,0.28)]">
                <span className="bg-gradient-to-r from-[#0f172a] via-[#204b97] to-[#5d83f3] bg-clip-text text-xs font-bold uppercase tracking-[0.22em] text-transparent">
                  Desarrollado por Zentra Group
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}